import auth from "./Auth";
import dashboard from "./Dashboard";
import manageCms from "./ManageCms/index";
import adminProfile from "./AdminAccount/index";
import manageUser from "./ManageUser/index";
import manageBiographies from "./ManageBiographies/index";
import manageSubscription from "./ManageSubscription/index";
import transactionHitory from "./TransactionHistory/index";
import reportCategory from "./ReportCategory/index";
import notifications from "./Notification/index";
import manageSupport from "./ManageSupport/index";
import manageCoupen from "./ManageCoupen/index";

const AccessControl = {
  ...auth,
  ...dashboard,
  ...manageCms,
  ...manageUser,
  ...manageBiographies,
  ...manageSubscription,
  ...manageCoupen,
  ...manageSupport,
  ...transactionHitory,
  ...reportCategory,
  ...adminProfile,
  ...notifications,
};

export default AccessControl;
